module.exports = "/assets/about/fourth/marcin.png?vUVzo5i";